import { createTargetSelector } from '../Redux/utils'

// Client utilities

export const createSubmitTargetSelector = () => createTargetSelector('submit')
export const createDataTargetSelector = () => createTargetSelector('data')
export const createMetaTargetSelector = () => createTargetSelector('meta')
export const createStateTargetSelector = () => createTargetSelector('state')
export const createFormTargetSelector = () => createTargetSelector('form')
export const createFilterTargetSelector = () => createTargetSelector('filter')

/**
 * @deprecated
 */
export const getSubmitTarget = createSubmitTargetSelector()

export const ACTION_SAVE = 'actionSave'
export const ACTION = 'action'
export const SAVE_REQUEST = 'save_request'
export const SAVE = 'save'
export const DELETE = 'delete'
export const RELOAD = 'reload'
export const DEFAULTS = 'defaults'
export const IMPORT = 'import'

export const isValueSet = (value) => value !== undefined

export const isDataNotEmpty = (data) => !!data && data.size > 0 && data.some(isValueSet)
